import { EntityModel } from './../../ng3/model';
import { GrayImage3 } from './image';
import { Vector3, Vector2, Color, OrthographicCamera, PerspectiveCamera } from 'three';
import { Colormap, Colormaps } from './colormap';
import { Slicer } from './slice';
import { GrayImage2WindowFilter } from './filter';

export class ImageState {
  constructor(
    public id: string,
    public image: GrayImage3 = new GrayImage3(
      new Vector3(0, 0, 0),
      new Vector3(1, 1, 0),
      new Vector3(1, 1, 0),
      new Float32Array([1]),
    ),
    public colormap: Colormap = Colormaps.GRAY,
    public slicer: Slicer = new Slicer(),
    public filter: GrayImage2WindowFilter = new GrayImage2WindowFilter(1, 0),
    public minMax: Vector2 = new Vector2(0, 1.0),
    public rotation: Vector3 = new Vector3(0, 0, 0),
  ) {}
}

export class EntityState {
  constructor(
    public canvasId: string,
    public id: string,
    public model: EntityModel ,
    public color: Color = new Color(60, 179, 113),
  ) {}
}

export class CanvasState {
  constructor(
    public id: string,
    // public image: ImageState,
    // public toolEntity: EntityState[],
    // public camara: OrthographicCamera | PerspectiveCamera,
  ) {}
}

export interface ImageWindow {
  width: number;
  level: number;
}
